export default __webpack_public_path__ + "static/media/public.1a15fab5.svg";